'use client';
import { createComponent } from '@stencil/react-output-target/runtime';
import { BiAccordionContent as BiAccordionContentElement, defineCustomElement as defineBiAccordionContent } from "bi-web-components/dist/components/bi-accordion-content.js";
import { BiAccordionGroup as BiAccordionGroupElement, defineCustomElement as defineBiAccordionGroup } from "bi-web-components/dist/components/bi-accordion-group.js";
import { BiAccordionHeader as BiAccordionHeaderElement, defineCustomElement as defineBiAccordionHeader } from "bi-web-components/dist/components/bi-accordion-header.js";
import { BiAccordion as BiAccordionElement, defineCustomElement as defineBiAccordion } from "bi-web-components/dist/components/bi-accordion.js";
import { BiAlert as BiAlertElement, defineCustomElement as defineBiAlert } from "bi-web-components/dist/components/bi-alert.js";
import { BiArticleContainer as BiArticleContainerElement, defineCustomElement as defineBiArticleContainer } from "bi-web-components/dist/components/bi-article-container.js";
import { BiArticle as BiArticleElement, defineCustomElement as defineBiArticle } from "bi-web-components/dist/components/bi-article.js";
import { BiAsset as BiAssetElement, defineCustomElement as defineBiAsset } from "bi-web-components/dist/components/bi-asset.js";
import { BiBadge as BiBadgeElement, defineCustomElement as defineBiBadge } from "bi-web-components/dist/components/bi-badge.js";
import { BiBreadcrumbItem as BiBreadcrumbItemElement, defineCustomElement as defineBiBreadcrumbItem } from "bi-web-components/dist/components/bi-breadcrumb-item.js";
import { BiBreadcrumbs as BiBreadcrumbsElement, defineCustomElement as defineBiBreadcrumbs } from "bi-web-components/dist/components/bi-breadcrumbs.js";
import { BiBulletItem as BiBulletItemElement, defineCustomElement as defineBiBulletItem } from "bi-web-components/dist/components/bi-bullet-item.js";
import { BiBulletList as BiBulletListElement, defineCustomElement as defineBiBulletList } from "bi-web-components/dist/components/bi-bullet-list.js";
import { BiButtonGroup as BiButtonGroupElement, defineCustomElement as defineBiButtonGroup } from "bi-web-components/dist/components/bi-button-group.js";
import { BiButton as BiButtonElement, defineCustomElement as defineBiButton } from "bi-web-components/dist/components/bi-button.js";
import { BiCalendarContainer as BiCalendarContainerElement, defineCustomElement as defineBiCalendarContainer } from "bi-web-components/dist/components/bi-calendar-container.js";
import { BiCalendarItem as BiCalendarItemElement, defineCustomElement as defineBiCalendarItem } from "bi-web-components/dist/components/bi-calendar-item.js";
import { BiCardActionArea as BiCardActionAreaElement, defineCustomElement as defineBiCardActionArea } from "bi-web-components/dist/components/bi-card-action-area.js";
import { BiCardAction as BiCardActionElement, defineCustomElement as defineBiCardAction } from "bi-web-components/dist/components/bi-card-action.js";
import { BiCardActions as BiCardActionsElement, defineCustomElement as defineBiCardActions } from "bi-web-components/dist/components/bi-card-actions.js";
import { BiCardContent as BiCardContentElement, defineCustomElement as defineBiCardContent } from "bi-web-components/dist/components/bi-card-content.js";
import { BiCardHeader as BiCardHeaderElement, defineCustomElement as defineBiCardHeader } from "bi-web-components/dist/components/bi-card-header.js";
import { BiCardMedia as BiCardMediaElement, defineCustomElement as defineBiCardMedia } from "bi-web-components/dist/components/bi-card-media.js";
import { BiCard as BiCardElement, defineCustomElement as defineBiCard } from "bi-web-components/dist/components/bi-card.js";
import { BiCheckbox as BiCheckboxElement, defineCustomElement as defineBiCheckbox } from "bi-web-components/dist/components/bi-checkbox.js";
import { BiChip as BiChipElement, defineCustomElement as defineBiChip } from "bi-web-components/dist/components/bi-chip.js";
import { BiDialog as BiDialogElement, defineCustomElement as defineBiDialog } from "bi-web-components/dist/components/bi-dialog.js";
import { BiDrawer as BiDrawerElement, defineCustomElement as defineBiDrawer } from "bi-web-components/dist/components/bi-drawer.js";
import { BiDropdownItem as BiDropdownItemElement, defineCustomElement as defineBiDropdownItem } from "bi-web-components/dist/components/bi-dropdown-item.js";
import { BiDropdown as BiDropdownElement, defineCustomElement as defineBiDropdown } from "bi-web-components/dist/components/bi-dropdown.js";
import { BiFieldset as BiFieldsetElement, defineCustomElement as defineBiFieldset } from "bi-web-components/dist/components/bi-fieldset.js";
import { BiFooterLinks as BiFooterLinksElement, defineCustomElement as defineBiFooterLinks } from "bi-web-components/dist/components/bi-footer-links.js";
import { BiFooter as BiFooterElement, defineCustomElement as defineBiFooter } from "bi-web-components/dist/components/bi-footer.js";
import { BiGridContainer as BiGridContainerElement, defineCustomElement as defineBiGridContainer } from "bi-web-components/dist/components/bi-grid-container.js";
import { BiHeader as BiHeaderElement, defineCustomElement as defineBiHeader } from "bi-web-components/dist/components/bi-header.js";
import { BiHeroCardContent as BiHeroCardContentElement, defineCustomElement as defineBiHeroCardContent } from "bi-web-components/dist/components/bi-hero-card-content.js";
import { BiHeroCard as BiHeroCardElement, defineCustomElement as defineBiHeroCard } from "bi-web-components/dist/components/bi-hero-card.js";
import { BiHeroModule as BiHeroModuleElement, defineCustomElement as defineBiHeroModule } from "bi-web-components/dist/components/bi-hero-module.js";
import { BiInPageLinks as BiInPageLinksElement, defineCustomElement as defineBiInPageLinks } from "bi-web-components/dist/components/bi-in-page-links.js";
import { BiInputField as BiInputFieldElement, defineCustomElement as defineBiInputField } from "bi-web-components/dist/components/bi-input-field.js";
import { BiLinkCard as BiLinkCardElement, defineCustomElement as defineBiLinkCard } from "bi-web-components/dist/components/bi-link-card.js";
import { BiLink as BiLinkElement, defineCustomElement as defineBiLink } from "bi-web-components/dist/components/bi-link.js";
import { BiListItem as BiListItemElement, defineCustomElement as defineBiListItem } from "bi-web-components/dist/components/bi-list-item.js";
import { BiList as BiListElement, defineCustomElement as defineBiList } from "bi-web-components/dist/components/bi-list.js";
import { BiLogo as BiLogoElement, defineCustomElement as defineBiLogo } from "bi-web-components/dist/components/bi-logo.js";
import { BiMessageBox as BiMessageBoxElement, defineCustomElement as defineBiMessageBox } from "bi-web-components/dist/components/bi-message-box.js";
import { BiModal as BiModalElement, defineCustomElement as defineBiModal } from "bi-web-components/dist/components/bi-modal.js";
import { BiNavbar as BiNavbarElement, defineCustomElement as defineBiNavbar } from "bi-web-components/dist/components/bi-navbar.js";
import { BiNotification as BiNotificationElement, defineCustomElement as defineBiNotification } from "bi-web-components/dist/components/bi-notification.js";
import { BiPagination as BiPaginationElement, defineCustomElement as defineBiPagination } from "bi-web-components/dist/components/bi-pagination.js";
import { BiRadioButton as BiRadioButtonElement, defineCustomElement as defineBiRadioButton } from "bi-web-components/dist/components/bi-radio-button.js";
import { BiSearch as BiSearchElement, defineCustomElement as defineBiSearch } from "bi-web-components/dist/components/bi-search.js";
import { BiSelectMultiple as BiSelectMultipleElement, defineCustomElement as defineBiSelectMultiple } from "bi-web-components/dist/components/bi-select-multiple.js";
import { BiSelectOption as BiSelectOptionElement, defineCustomElement as defineBiSelectOption } from "bi-web-components/dist/components/bi-select-option.js";
import { BiSelect as BiSelectElement, defineCustomElement as defineBiSelect } from "bi-web-components/dist/components/bi-select.js";
import { BiShare as BiShareElement, defineCustomElement as defineBiShare } from "bi-web-components/dist/components/bi-share.js";
import { BiSpinner as BiSpinnerElement, defineCustomElement as defineBiSpinner } from "bi-web-components/dist/components/bi-spinner.js";
import { BiTitleSeparator as BiTitleSeparatorElement, defineCustomElement as defineBiTitleSeparator } from "bi-web-components/dist/components/bi-title-separator.js";
import { BiTypography as BiTypographyElement, defineCustomElement as defineBiTypography } from "bi-web-components/dist/components/bi-typography.js";
import React from 'react';
export const BiAccordion = /*@__PURE__*/ createComponent({
    tagName: 'bi-accordion',
    elementClass: BiAccordionElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onToggle: 'toggle',
        onOpen: 'open',
        onClose: 'close'
    },
    defineCustomElement: defineBiAccordion
});
export const BiAccordionContent = /*@__PURE__*/ createComponent({
    tagName: 'bi-accordion-content',
    elementClass: BiAccordionContentElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiAccordionContent
});
export const BiAccordionGroup = /*@__PURE__*/ createComponent({
    tagName: 'bi-accordion-group',
    elementClass: BiAccordionGroupElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiAccordionGroup
});
export const BiAccordionHeader = /*@__PURE__*/ createComponent({
    tagName: 'bi-accordion-header',
    elementClass: BiAccordionHeaderElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiAccordionHeader
});
export const BiAlert = /*@__PURE__*/ createComponent({
    tagName: 'bi-alert',
    elementClass: BiAlertElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiAlert
});
export const BiArticle = /*@__PURE__*/ createComponent({
    tagName: 'bi-article',
    elementClass: BiArticleElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiArticle
});
export const BiArticleContainer = /*@__PURE__*/ createComponent({
    tagName: 'bi-article-container',
    elementClass: BiArticleContainerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiArticleContainer
});
export const BiAsset = /*@__PURE__*/ createComponent({
    tagName: 'bi-asset',
    elementClass: BiAssetElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiAsset
});
export const BiBadge = /*@__PURE__*/ createComponent({
    tagName: 'bi-badge',
    elementClass: BiBadgeElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiBadge
});
export const BiBreadcrumbItem = /*@__PURE__*/ createComponent({
    tagName: 'bi-breadcrumb-item',
    elementClass: BiBreadcrumbItemElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiBreadcrumbItem
});
export const BiBreadcrumbs = /*@__PURE__*/ createComponent({
    tagName: 'bi-breadcrumbs',
    elementClass: BiBreadcrumbsElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiBreadcrumbs
});
export const BiBulletItem = /*@__PURE__*/ createComponent({
    tagName: 'bi-bullet-item',
    elementClass: BiBulletItemElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiBulletItem
});
export const BiBulletList = /*@__PURE__*/ createComponent({
    tagName: 'bi-bullet-list',
    elementClass: BiBulletListElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiBulletList
});
export const BiButton = /*@__PURE__*/ createComponent({
    tagName: 'bi-button',
    elementClass: BiButtonElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiButton
});
export const BiButtonGroup = /*@__PURE__*/ createComponent({
    tagName: 'bi-button-group',
    elementClass: BiButtonGroupElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiButtonGroup
});
export const BiCalendarContainer = /*@__PURE__*/ createComponent({
    tagName: 'bi-calendar-container',
    elementClass: BiCalendarContainerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCalendarContainer
});
export const BiCalendarItem = /*@__PURE__*/ createComponent({
    tagName: 'bi-calendar-item',
    elementClass: BiCalendarItemElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCalendarItem
});
export const BiCard = /*@__PURE__*/ createComponent({
    tagName: 'bi-card',
    elementClass: BiCardElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCard
});
export const BiCardAction = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-action',
    elementClass: BiCardActionElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardAction
});
export const BiCardActionArea = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-action-area',
    elementClass: BiCardActionAreaElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardActionArea
});
export const BiCardActions = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-actions',
    elementClass: BiCardActionsElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardActions
});
export const BiCardContent = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-content',
    elementClass: BiCardContentElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardContent
});
export const BiCardHeader = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-header',
    elementClass: BiCardHeaderElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardHeader
});
export const BiCardMedia = /*@__PURE__*/ createComponent({
    tagName: 'bi-card-media',
    elementClass: BiCardMediaElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiCardMedia
});
export const BiCheckbox = /*@__PURE__*/ createComponent({
    tagName: 'bi-checkbox',
    elementClass: BiCheckboxElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onChange: 'change',
        onBlur: 'blur'
    },
    defineCustomElement: defineBiCheckbox
});
export const BiChip = /*@__PURE__*/ createComponent({
    tagName: 'bi-chip',
    elementClass: BiChipElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiChip
});
export const BiDialog = /*@__PURE__*/ createComponent({
    tagName: 'bi-dialog',
    elementClass: BiDialogElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onClose: 'close' },
    defineCustomElement: defineBiDialog
});
export const BiDrawer = /*@__PURE__*/ createComponent({
    tagName: 'bi-drawer',
    elementClass: BiDrawerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onClose: 'close' },
    defineCustomElement: defineBiDrawer
});
export const BiDropdown = /*@__PURE__*/ createComponent({
    tagName: 'bi-dropdown',
    elementClass: BiDropdownElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onOpen: 'open',
        onClose: 'close'
    },
    defineCustomElement: defineBiDropdown
});
export const BiDropdownItem = /*@__PURE__*/ createComponent({
    tagName: 'bi-dropdown-item',
    elementClass: BiDropdownItemElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiDropdownItem
});
export const BiFieldset = /*@__PURE__*/ createComponent({
    tagName: 'bi-fieldset',
    elementClass: BiFieldsetElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiFieldset
});
export const BiFooter = /*@__PURE__*/ createComponent({
    tagName: 'bi-footer',
    elementClass: BiFooterElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiFooter
});
export const BiFooterLinks = /*@__PURE__*/ createComponent({
    tagName: 'bi-footer-links',
    elementClass: BiFooterLinksElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiFooterLinks
});
export const BiGridContainer = /*@__PURE__*/ createComponent({
    tagName: 'bi-grid-container',
    elementClass: BiGridContainerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiGridContainer
});
export const BiHeader = /*@__PURE__*/ createComponent({
    tagName: 'bi-header',
    elementClass: BiHeaderElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiHeader
});
export const BiHeroCard = /*@__PURE__*/ createComponent({
    tagName: 'bi-hero-card',
    elementClass: BiHeroCardElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiHeroCard
});
export const BiHeroCardContent = /*@__PURE__*/ createComponent({
    tagName: 'bi-hero-card-content',
    elementClass: BiHeroCardContentElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiHeroCardContent
});
export const BiHeroModule = /*@__PURE__*/ createComponent({
    tagName: 'bi-hero-module',
    elementClass: BiHeroModuleElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiHeroModule
});
export const BiInPageLinks = /*@__PURE__*/ createComponent({
    tagName: 'bi-in-page-links',
    elementClass: BiInPageLinksElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiInPageLinks
});
export const BiInputField = /*@__PURE__*/ createComponent({
    tagName: 'bi-input-field',
    elementClass: BiInputFieldElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onChange: 'change',
        onBlur: 'blur',
        onInput: 'input'
    },
    defineCustomElement: defineBiInputField
});
export const BiLink = /*@__PURE__*/ createComponent({
    tagName: 'bi-link',
    elementClass: BiLinkElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiLink
});
export const BiLinkCard = /*@__PURE__*/ createComponent({
    tagName: 'bi-link-card',
    elementClass: BiLinkCardElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiLinkCard
});
export const BiList = /*@__PURE__*/ createComponent({
    tagName: 'bi-list',
    elementClass: BiListElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiList
});
export const BiListItem = /*@__PURE__*/ createComponent({
    tagName: 'bi-list-item',
    elementClass: BiListItemElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiListItem
});
export const BiLogo = /*@__PURE__*/ createComponent({
    tagName: 'bi-logo',
    elementClass: BiLogoElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiLogo
});
export const BiMessageBox = /*@__PURE__*/ createComponent({
    tagName: 'bi-message-box',
    elementClass: BiMessageBoxElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiMessageBox
});
export const BiModal = /*@__PURE__*/ createComponent({
    tagName: 'bi-modal',
    elementClass: BiModalElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onToggleOpen: 'toggleOpen',
        onCloseModal: 'closeModal'
    },
    defineCustomElement: defineBiModal
});
export const BiNavbar = /*@__PURE__*/ createComponent({
    tagName: 'bi-navbar',
    elementClass: BiNavbarElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiNavbar
});
export const BiNotification = /*@__PURE__*/ createComponent({
    tagName: 'bi-notification',
    elementClass: BiNotificationElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiNotification
});
export const BiPagination = /*@__PURE__*/ createComponent({
    tagName: 'bi-pagination',
    elementClass: BiPaginationElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onPageChanged: 'pageChanged' },
    defineCustomElement: defineBiPagination
});
export const BiRadioButton = /*@__PURE__*/ createComponent({
    tagName: 'bi-radio-button',
    elementClass: BiRadioButtonElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onChange: 'change',
        onBlur: 'blur'
    },
    defineCustomElement: defineBiRadioButton
});
export const BiSearch = /*@__PURE__*/ createComponent({
    tagName: 'bi-search',
    elementClass: BiSearchElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onQueryChange: 'queryChange',
        onSearch: 'search'
    },
    defineCustomElement: defineBiSearch
});
export const BiSelect = /*@__PURE__*/ createComponent({
    tagName: 'bi-select',
    elementClass: BiSelectElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onChange: 'change',
        onBlur: 'blur'
    },
    defineCustomElement: defineBiSelect
});
export const BiSelectMultiple = /*@__PURE__*/ createComponent({
    tagName: 'bi-select-multiple',
    elementClass: BiSelectMultipleElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onChange: 'change',
        onBlur: 'blur'
    },
    defineCustomElement: defineBiSelectMultiple
});
export const BiSelectOption = /*@__PURE__*/ createComponent({
    tagName: 'bi-select-option',
    elementClass: BiSelectOptionElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiSelectOption
});
export const BiShare = /*@__PURE__*/ createComponent({
    tagName: 'bi-share',
    elementClass: BiShareElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiShare
});
export const BiSpinner = /*@__PURE__*/ createComponent({
    tagName: 'bi-spinner',
    elementClass: BiSpinnerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiSpinner
});
export const BiTitleSeparator = /*@__PURE__*/ createComponent({
    tagName: 'bi-title-separator',
    elementClass: BiTitleSeparatorElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiTitleSeparator
});
export const BiTypography = /*@__PURE__*/ createComponent({
    tagName: 'bi-typography',
    elementClass: BiTypographyElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {},
    defineCustomElement: defineBiTypography
});
